module.exports = __webpack_public_path__ + "static/media/red-rose.1bdfbb12.png";